import { Empty, FormItemProps } from 'antd';
import { useTranslation } from 'react-i18next';

export const Additional = () => {
  const { t } = useTranslation();
  const noData = <Empty description={t("global.Ma'lumotlar mavjud emas")} />;
  const requiredRule: FormItemProps['rules'] = [{ required: true, message: '' }];
  const label = (text: React.ReactNode) => <div className="text-sm font-medium text-gray-500">{text}</div>;

  return { noData, requiredRule, label };
};
